import ReactPlayer from "react-player";

const VideoPlayer = ({ url }) => {
  return <ReactPlayer width="100%" height="100%" controls={true} url={url} />;
};

export default VideoPlayer;
